import "./Login.css";
import TimLogoLama from "../../asset/tim-lama.jpeg";
import LoginImage from "../../asset/login-image-absent.png";
import { useLogin } from "./useLogin";
import { Redirect } from "react-router-dom";

const Login = () => {
  const { setValueUsername, setValuePassword, handleLogin, statusCode } =
    useLogin();
  return (
    <>
      {statusCode === 200 ? (
        <Redirect push to="/dashboard" />
      ) : (
        <div className="page-login">
          <div className="container-login">
            <div className="wrapper-left-login">
              <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    style={{
                      width: "32px",
                      height: "32px",
                      marginRight: "10px",
                    }}
                    src={TimLogoLama}
                  />
                  <p
                    style={{
                      fontSize: "24px",
                      color: "white",
                      fontWeight: "600",
                      margin: 0,
                    }}
                  >
                    Tenar Inti Mandiri
                  </p>
                </div>
                <p
                  style={{
                    fontSize: "18px",
                    color: "white",
                    fontWeight: "600",
                  }}
                >
                  Attendance Management System
                </p>
              </div>
              <img style={{ maxWidth: "80%" }} src={LoginImage} />
            </div>
            <div className="wrapper-right-login">
              <div className="padding-wrapper-right-login">
                <div className="wrapper-show-mobile">
                  <p style={{ fontSize: "24px", color: "white" }}>
                    Tenar Inti Mandiri
                  </p>
                  <img className="img-left-mobile" src={LoginImage} />
                </div>
                <p className="signin-title">Sign in</p>
                <input
                  type="text"
                  placeholder="Username"
                  className="input-login"
                  style={{
                    margin: "18px 0 12px 0",
                  }}
                  onChange={(e) => {
                    setValueUsername(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleLogin();
                    }
                  }}
                />

                <input
                  type="password"
                  placeholder="Password"
                  className="input-login"
                  onChange={(e) => setValuePassword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleLogin();
                    }
                  }}
                />

                <div className="button-signin" onClick={() => handleLogin()}>
                  Sign in
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Login;
